import type { LowercaseLetter } from "@/components/shared/FilterLetters/filterLetters.types";
import type { BreedList, SpeciesType } from "../breeds.types";

export const useBreedGlossary = (filters: BreedList) => {
  const speciesBreeds: SpeciesType[] = [
    {
      name: "cachorro",
      description:
        "Saiba os principais cuidados e outras informações importantes sobre os cães",
      path: "/cachorro",
      image: "/inst/img/breeds/dog.png"
    },
    {
      name: "gato",
      description:
        "Conheça as principais características e diferenças das raças de gatos",
      path: "/gato",
      image: "/inst/img/breeds/cat.png"
    }
  ];

  const breedLetters = filters.map((breed) =>
    breed.name.charAt(0).toLocaleLowerCase()
  ) as LowercaseLetter[];

  const filterRepeatedLetters = () => {
    return Array.from(new Set(breedLetters));
  };

  const filterLetters = filterRepeatedLetters();

  const getUniqueAndSortedLetters = () => {
    return Array.from(new Set(filterLetters)).sort((a, b) =>
      a.localeCompare(b)
    );
  };

  const uniqueBreedLetters = getUniqueAndSortedLetters();

  const handleLetterClick = (letter: LowercaseLetter) => {
    const breedCardElement = document.getElementById(`letter-${letter}`);
    if (breedCardElement) {
      const targetPosition =
        breedCardElement.getBoundingClientRect().top + window.scrollY;

      const scrollYOffset = 150;

      const scrollToTop = targetPosition - scrollYOffset;

      window.scrollTo({
        top: scrollToTop,
        behavior: "smooth"
      });
    }
  };

  return {
    speciesBreeds,
    uniqueBreedLetters,
    handleLetterClick
  };
};

export default useBreedGlossary;
